document.addEventListener("DOMContentLoaded", () => {
  const button_test = document.querySelector("#test1");
  if (button_test) {
    button_test.addEventListener("click", () => {
      const event = new CustomEvent("g_test");
      button_test.dispatchEvent(event);
      
      // 获取 #ppp1 元素的文本并转换为数值
      const valueText = document.querySelector("#ppp1") ? document.querySelector("#ppp1").innerText : "0";
      const value = parseFloat(valueText.replace(/[^\d.]/g, ''));  // 去掉非数字字符并转换为浮点数
      
      // 触发 gtag 事件
      gtag('event', 'g_test', {
        currency: 'USD',
        items: [{
          item_id: 'SKU_12345',
          item_name: 'jeggings',
          coupon: 'SUMMER_FUN',
          item_variant: 'black',
          price: 9.99,
          currency: 'USD',
          quantity: 1
        }],
        value: value
      });
      
    });
  }
});
